export const APP_LOGIN = 'APP:LOGIN';
export const APP_LOGOUT = 'APP:LOGOUT';
export const FATAL_ERROR = 'APP:FATAL_ERROR';
export const NETWORK_ERROR = 'APP:NETWORK_ERROR';
export const ROOT_CLICK = 'APP:ROOT_CLICK';
export const TOGGLE_MENU = 'APP:TOGGLE_MENU';
